export const PLAYBOOK = {
  id: "freight-operations-playbook",
  version: "2026.09.1",
  title: "The Freight Operations Playbook",
  subtitle: "A calmer desk. A sharper operation.",
  currency: "usd",
  priceCents: 3700,
  files: [
    [
      "01",
      "The field guide",
      "A practical operating rhythm for intake, tracking, exceptions and a clean handoff.",
    ],
    [
      "02",
      "Five editable SOPs",
      "Give every load a clear owner, next action and escalation point.",
    ],
    [
      "03",
      "The communications kit",
      "Customer updates and carrier follow-ups you can adapt in minutes.",
    ],
    [
      "04",
      "The exception tracker",
      "A spreadsheet-ready queue with a worked example and clear field definitions.",
    ],
    [
      "05",
      "The operations scorecard",
      "Measure follow-through, missing documents and work that needs attention.",
    ],
    [
      "06",
      "AI workflow cards",
      "Turn source facts into useful drafts, with checks before anything gets sent.",
    ],
  ],
} as const;

export function emailAddress(value: string) {
  const email = value.trim().toLowerCase();
  if (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
    throw new Error("Enter a valid work email.");
  return email;
}
export function bounded(value: string, name: string, min = 1, max = 1000) {
  const text = value.trim();
  if (text.length < min || text.length > max)
    throw new Error(`${name} must be ${min}–${max} characters.`);
  return text;
}
